var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757",
    transform: "translate(-336 -184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down_3_",
    "data-name": "chevron-down (3)",
    d: "M6,13.63,10.63,9l4.63,4.63",
    transform: "translate(334.37 181.685)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 18,
    height: 18,
    transform: "translate(336 184)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowBlackIcon);
export default __webpack_public_path__ + "static/media/up-arrow-black-icon.7c0e880cb17ee8d48208b981e0a28eb0.svg";
export { ForwardRef as ReactComponent };